export const ID_CAPA = {
  galleta: "galleta_actores",
  paises: "paises_actores",
  estados: "estados_actores",
};

export const coloresLineasEstrategicas = {
  "00": "#494949",
  "01": "#C51228",
  "02": "#FF5500",
  "03": "#DB16A3",
  "04": "#7D1DD8",
  "05": "#262699",
  "06": "#438BFF",
  "07": "#1263FC",
  "08": "#0A7F94",
  "09": "#054C32",
  10: "#42A542",
};

export function obtenerFeatureExtent(capa, findFunction) {
  return capa.getSource().getFeatures().find(findFunction).getGeometry().getExtent();
}

export const idMexico = require("@/assets/data/diccionarios/lista_paises.json").find(
  (pais) => pais.pais === "México"
).codigo_pais;

export function contarRepetidos(array, by = undefined) {
  return array.reduce((accumulator, value) => {
    value =
      (typeof by === typeof Number() || typeof by === typeof String()) && by !== ""
        ? value[by]
        : value;
    return { ...accumulator, [value]: (accumulator[value] || 0) + 1 };
  }, {});
}

export function filtrarCapaActores(capaActores, ubicacionesFiltradas) {
  /**
   * Ubicaciobes repetidas segun la selección (store)
   * Formato: { id_ubicacion: n_repeticiones}
   * Ejemplo: { 1: 10, 2: 4, 3: 0 }
   */
  let ubicacionesRepetidas = contarRepetidos(ubicacionesFiltradas);

  // Filtrar los puntos de las ubicaciones filtradas
  let capa = capaActores.geojsonFiltro((f) => ubicacionesFiltradas.includes(f.properties.g_id));

  capa.bbox =
    capa.features.length > 1
      ? capaActores.limitesTotalesFiltro((f) => ubicacionesFiltradas.includes(f.properties.g_id))
      : [undefined, undefined, undefined, undefined];

  // Añadir reconteo de actores por ubicaciones filtradas
  capa.features = capa.features.map((f) => {
    f.properties.reconteo = ubicacionesRepetidas[f.properties.g_id] ?? 0;
    return f;
  });

  return capa;
}
